export default __webpack_public_path__ + "static/media/icon-points.0afaa353.svg";